<h3 mat-dialog-title class="title-layout">Resolve Base Variant Configuration Error </h3>

<div mat-dialog-content>
  
<p>You cannot use the base variant, <span style="font-weight: 500;">{{baseVariant.variant_name}}</span>, on a pitch with other defined variants. 
   To resolve this error you should define a new variant (below) that specifies 
   the model variants the work is performed for, or you can remove all non-base variants 
    from the pitch.</p>

   <h4>Select model variants to define a new pitch variant:</h4>

<form [formGroup]="fg_VariantConfig" >
   <mat-form-field class="card-dialog">
    <mat-label>New Pitch Variant</mat-label>
        <mat-select id="type" matInput cdkTextareaAutosize formControlName="f_ModelVariants" multiple>
          <mat-select-trigger>
              <span *ngIf="selectedModelsList.length > 0">
                  {{ selectedModelsList.join('/') }}
              </span>
          </mat-select-trigger>
          
          <mat-option *ngFor="let model of modelVariantList" [value]="model">
            {{model.model_name}}
          </mat-option>
        </mat-select>
    </mat-form-field>
      <div *ngIf="fg_VariantConfig.get('f_ModelVariants').invalid && 
          fg_VariantConfig.get('f_ModelVariants').errors && 
          (fg_VariantConfig.get('f_ModelVariants').dirty || fg_VariantConfig.get('f_ModelVariants').touched)">
        <small class="error" *ngIf="fg_VariantConfig.get('f_ModelVariants').hasError('required')">
          At least one Model Variant must be selected..
        </small>
      </div>

      </form>

      <span *ngIf = "selectedModelVariants.length > 0">
        <p>
          All work currently assigned to the base variant, <span style="font-weight: 500;">{{baseVariant.variant_name}}</span>, 
          will be transferred to the new pitch variant, <span style="font-weight: 500;">{{selectedModelsList.join('/')}}</span>.
        </p>
      </span>

      <span *ngIf = "selectedModelVariants.length == 0" style="color: red;">
        <p>
          <span style="font-weight:500;">Warning!</span> No new variant will be added. 
            On <span style="font-weight: 500;">Submit</span>, pitch variant {{ baseVariant.variant_name }} will be removed from the pitch.
          </p>
      </span>


</div>

<div mat-dialog-actions>
    <button mat-button color="primary" (click)="onSubmit()">Submit</button>
    <button mat-button (click)="onNoClick()">Cancel</button>
</div>

<div *ngIf="isBusy">
    <mat-spinner></mat-spinner>
</div>
